<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-jump" @click="exitStudioTips">
          退出工作室<i class="el-icon-arrow-right"></i>
        </div>
        <div class="title-name">基础信息</div>
      </div>
      <div class="content-inner-wrap">
        <div class="studio-info" :data-studioi="studioId">
          <img class="avatar" :src="studioHead" />
          <div class="info">
            <h2>{{ studioName }}</h2>
            <p>室长：{{ leaderName }}</p>
          </div>
        </div>
        <div class="info-item studio-desc">
          <div class="label">简介：</div>
          <div class="details">{{ description }}</div>
        </div>
        <div class="info-item studio-notice">
          <div class="label">公告：</div>
          <div class="details">
            {{ notice }}
          </div>
        </div>
      </div>
    </div>
    <div class="block block-myProfit">
      <div class="title-wrap">
        <div class="title-name">我的信息</div>
      </div>
      <div class="content-inner-wrap">
        <ul class="myProfitItems">
          <li>
            <p>已加入</p>
            <label>{{ join_time | areadyJoinTime }}<i>天</i></label>
          </li>
          <li>
            <p>职位</p>
            <label>{{ currMemberType }}</label>
          </li>
          <li>
            <p>我的作品</p>
            <label>{{ my_map_count }}</label>
          </li>
          <!--  屏蔽收益
          <li>
            <p>作品收益</p>
            <label>{{total_money}}</label>
          </li>
  -->
        </ul>
      </div>
    </div>
    <div class="block-wrap">
      <div class="block block-members">
        <div class="title-wrap">
          <div class="title-name">成员列表</div>
        </div>
        <div class="content-inner-wrap" v-loading="memberListLoading">
          <div class="myTable-wrap">
            <el-table :data="membersData" stripe>
              <el-table-column
                align="center"
                prop="name"
                label="名称"
                class-name="tb-name"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="uin"
                label="迷你号"
                class-name="tb-uin"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="position"
                label="类型"
                class-name="tb-position"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row | positionName }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="data-filter-page" v-if="membersData.length">
            <span>共{{ total_count_member }}个成员</span>
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="memberPageChange"
              :pager-count="5"
              :total="total_count_member"
            >
            </el-pagination>
          </div>
          <div class="img-no-data" v-else>
            <img src="../../assets/images/img_map_no_data.png" />
            <p>您暂时还没有数据呢</p>
          </div>
        </div>
      </div>
      <div class="block block-rank">
        <div class="title-wrap">
          <div class="title-name">作品列表</div>
        </div>
        <div class="content-inner-wrap" v-loading="rankListLoading">
          <div class="rankItems">
            <div
              class="rankItem"
              v-for="(item, index) in productRankData"
              :key="index"
            >
              <img :src="item.thumb_url" v-if="item.thumb_url" />
              <img src="../../assets/images/img_map_no_url.png" v-else />
              <div class="rankInfo">
                <p>{{ item.name }}</p>
                <p class="author">
                  作者：<label>{{ item.uin_name }}</label>
                </p>
                <div class="rankData">
                  <div class="downloads">{{ item.download_count }}</div>
                  <div class="favorite">{{ item.collectc }}</div>
                  <div class="toukuai">{{ item.tips_total }}</div>
                </div>
              </div>
            </div>
            <div class="data-filter-page" v-if="productRankData.length">
              <span>共{{ total_count_rank }}个作品</span>
              <el-pagination
                background
                layout="prev, pager, next"
                :pager-count="5"
                @current-change="rankPageChange"
                :total="total_count_rank"
              >
              </el-pagination>
            </div>
            <div class="img-no-data" v-else>
              <img src="../../assets/images/img_map_no_data.png" />
              <p>您暂时还没有数据呢</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {
  getStudioDetail,
  getStudioIncomeOverview,
  getStudioMembers,
  getStudioMemberCount,
  getStudioProductList,
} from '@/api/studio';
import {
  STUDIO_POSITION,
  ONE_DAY,
  NOTICE_DEFAULT,
  DESCRIPTION_DEFAULT,
} from './CONST';

export default {
  data() {
    return {
      // paperCount: 4,
      membersData: [],
      productRankData: [],
      description: DESCRIPTION_DEFAULT,
      notice: NOTICE_DEFAULT,
      studioName: '',
      studioHead: '',
      studioId: 0,
      leaderName: '',
      rPagination: {
        page: 1,
        page_size: 6,
      },
      mPagination: {
        page: 1,
        page_size: 10,
      },
      total_count_member: 1,
      total_count_rank: 1,
      total_money: 0,
      memberListLoading: false,
      rankListLoading: false,
      my_map_count: 0,
      vip_member: 0,
      join_time: 0,
      position: 2,
    };
  },
  async mounted() {
    this.Report('view', 'StudioPage', { v3: 'member' });
    this.getBaseInfo();
    getStudioIncomeOverview().then(res => {
      let { total_money } = res.data;
      this.total_money = total_money;
    });
    this.getRankList();
    let res = await getStudioMemberCount({ json: 1 });
    let { count } = res.data;
    this.total_count_member = parseInt(count, 10);
    this.getMemberList();
  },
  filters: {
    positionName(member) {
      if (member.position === 2 && member.vip) {
        return '签约成员';
      } else {
        return STUDIO_POSITION[member.position].value;
      }
    },
    areadyJoinTime(time) {
      if (Number.isNaN(time)) return 0;
      let diffDay = Date.now() - time * 1000;
      return Math.floor(diffDay / ONE_DAY);
    },
  },
  computed: {
    ...mapState(['userInfo']),
    currMemberType: function () {
      if (this.position === 2 && this.vip_member) return '签约成员';
      return STUDIO_POSITION[this.position].value;
    },
  },
  methods: {
    exitStudioTips() {
      this.$alert('请前往游戏客户端 - 个人中心 - 工作室 中申请退出', '提示', {
        confirmButtonText: '确定',
        callback: action => console.log(action),
      });
    },
    handleBaseInfo(baseInfo) {
      this.description = baseInfo.description || DESCRIPTION_DEFAULT;
      this.notice = baseInfo.notice || NOTICE_DEFAULT;
      this.studioName = baseInfo.name;
      this.studioHead = baseInfo.head;
      this.leaderName = baseInfo.leader_name;
      this.studioId = baseInfo.studio_id;
      this.my_map_count = baseInfo.my_map_count;
      this.vip_member = baseInfo.vip_member;
      this.join_time = baseInfo.join_time;
      this.position = baseInfo.position;
    },
    getBaseInfo() {
      let baseInfo = sessionStorage.getItem('studioBaseInfo');
      if (baseInfo) {
        baseInfo = JSON.parse(baseInfo);
        this.handleBaseInfo(baseInfo);
      } else {
        getStudioDetail({ json: 1 }).then(res => {
          baseInfo = res.data;
          this.handleBaseInfo(baseInfo);
          sessionStorage.setItem('studioBaseInfo', JSON.stringify(baseInfo));
        });
      }
    },
    memberPageChange(page) {
      this.mPagination.page = page;
      this.getMemberList();
    },
    rankPageChange(page) {
      this.rPagination.page = page;
      this.getRankList();
    },
    getMemberList() {
      this.memberListLoading = true;
      getStudioMembers({ json: 1, ...this.mPagination }).then(res => {
        this.memberListLoading = false;
        this.membersData = res.data || [];
      });
    },
    getRankList() {
      this.rankListLoading = true;
      getStudioProductList({ json: 1, ...this.rPagination }).then(res => {
        this.rankListLoading = false;
        let { count, list } = res.data;
        this.productRankData = list || [];
        this.total_count_rank = count;
      });
    },
  },
};
</script>
<style
  src="../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.block-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .block-members {
    width: 436px;
  }
  .block-rank {
    width: 596px;
  }
  .block .content-inner-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.container .block-myProfit {
  .title-wrap {
    border-bottom: none;
    margin-bottom: 26px;
  }
}
.block {
  .content-inner-wrap {
    .studio-info {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .avatar {
        margin-right: 20px;
        width: 100px;
        height: 100px;
        border-radius: 8px;
        border: 1px solid #f565a5;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h2 {
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 16px;
          line-height: 21px;
        }
      }
    }
    .info-item {
      display: block;
      height: auto;
      overflow: hidden;
      margin-top: 20px;
      .label {
        width: 50px;
        float: left;
        font-size: 16px;
        line-height: 28px;
        color: #595959;
      }
      .details {
        width: 780px;
        float: left;
        font-size: 16px;
        line-height: 28px;
        color: #262626;
      }
    }
    .myProfitItems {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 30px;
      li {
        position: relative;
        width: 247px;
        text-align: left;
        padding-left: 76px;
        p {
          font-size: 16px;
          line-height: 21px;
          color: #262626;
          margin-bottom: 12px;
        }
        label {
          font-size: 24px;
          line-height: 31px;
          color: #fd9b21;
          i {
            font-size: 14px;
            line-height: 19px;
            margin-left: 17px;
            color: #8c8c8c;
          }
        }
        &:after {
          display: block;
          content: '';
          width: 1px;
          height: 48px;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto;
          background: #d9d9d9;
        }
        &:last-child::after {
          display: none;
        }
      }
    }
    .data-filter-page {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      span {
        margin: 0 30px 0 10px;
      }
    }
  }
}
.block-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .block {
    width: 516px;
    padding: 18px 31px 45px;
  }
}
.rankItem {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 20px;
  img {
    width: 132px;
    height: 80px;
    margin-right: 16px;
  }
  p {
    font-size: 14px;
    line-height: 19px;
    color: #262626;
    &.author {
      color: #595959;
      margin: 6px 0 13px;
      label {
        color: #fd9b21;
      }
    }
  }
  .rankInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .rankData {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 14px;
    line-height: 19px;
    color: #595959;
    > div {
      padding-left: 26px;
      background-position: left center;
      background-repeat: no-repeat;
      background-size: 20px;
      margin-right: 24px;
    }
    .downloads {
      background-image: url('../../assets/images/icon-downloads.svg');
    }
    .toukuai {
      background-image: url('../../assets/images/icon-toukuai.svg');
    }
    .favorite {
      background-image: url('../../assets/images/icon-favorite.svg');
    }
  }
}
</style>
